import { render, staticRenderFns } from "./VehicleProvisionBrigadesEdit.vue?vue&type=template&id=27f7f8ce&"
import script from "./VehicleProvisionBrigadesEdit.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionBrigadesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QIcon,QItem,QSelect,QCheckbox,QTooltip,QBtn,QBanner,QInnerLoading,QSpinnerGears,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QIcon,QItem,QSelect,QCheckbox,QTooltip,QBtn,QBanner,QInnerLoading,QSpinnerGears,QSeparator,QCardActions}, component.options.components || {})
